<style lang="scss" scoped>
.equ {
  width: 415px;
  height: 198px;
  margin-top: 20px;
  cursor: pointer;
  .lifts {
    margin-top: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-evenly;
    .data {
      height: 92px;
      font-size: 18px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .number {
        font-size: 48px;
        font-family: "dina";
      }
    }
    .data:nth-child(1) {
      .number {
        color: #2d82ff;
      }
    }
    .data:nth-child(2) {
      .number {
        color: #f1802f;
      }
    }
  }
}
</style>

<template>
  <div class="equ" @click="to('/gateway')">
    <custom-plane
      title="网关"
      :iconImg="require('@/assets/compImg/icon/icon-wg.png')"
    >
      <div class="lifts">
        <div v-for="(item, index) in GatewayList" :key="index" class="data">
          <p>{{ item.title }}</p>
          <p class="number">{{ item.num }}</p>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    GatewayList: Array,
  },
  methods:{
    to(path){
      this.$router.push({path})
    }
  }
};
</script>
